import * as React from "react";
import axios from "axios";
import {flashError} from "components/utils/Flash";
import Loading from "components/quotation/Loading";
import Details from "components/quotation/Details";
import Prices from "components/quotation/Prices";
import PriceDiscount from "components/quotation/PriceDiscount";
import Items from "components/quotation/Items";
import Notes from "components/quotation/Notes";
import {blankQuotation, Item, parseQuotation, Quotation} from "components/models/Quotation";
import Card from "react-bootstrap/Card";
import {CardDeck} from "react-bootstrap";

interface Props {
  id?: string;
  customerId?: string;
}

interface State {
  loading: boolean;
  quotation: Quotation;
}

export default class extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      loading: true,
      quotation: blankQuotation(),
    }

  }

  componentDidMount() {
    if (this.props.id && this.props.customerId) {
      this.loadQuotation();
    }
  }

  loadQuotation() {
    axios.get(`/customers/${this.props.customerId}/quotations/${this.props.id}.json`)
      .then((resp) => {
        this.setState({quotation: parseQuotation(resp.data), loading: false})
      })
      .catch(() => {
        flashError('An issue occurred loading the quotation', 'Error');
      })
  }

  addItem(item: Item) {
    this.setState((state) => ({
      quotation: Object.assign(state.quotation, {items: state.quotation.items.concat([item])})
    }))
  }

  loaded() {
    return <>
      <CardDeck>
        <Details quotation={this.state.quotation}/>
        <Prices/>
        <PriceDiscount/>
      </CardDeck>
      <Items items={this.state.quotation.items} onAdd={(item) => this.addItem(item)}/>
      <Notes notes={this.state.quotation.notes}/>
      <Card>
        <Card.Header>State</Card.Header>
        <Card.Body>
          <pre>{JSON.stringify(this.state, null, 2)}</pre>
        </Card.Body>
      </Card>
    </>
  }

  render() {
    return (
      <>
        <h1>Quotation {this.state.quotation.number ? `: ${this.state.quotation.number}` : '...'}</h1>
        {this.state.loading ? <Loading/> : this.loaded()}
      </>
    )
  }
}
